const validate = (values,discountCard) => {
    console.log("tarjeta",discountCard);
    
    const errors = {};
    if (!values.nit) {
        errors.nit = 'El campo de nit no debe estar vacio';
    } /*else if (!isCheckOK(values.nit)) {
        errors.nit = "Escriba el nit con el guion y seguido del numero de verificacion";
    }*/

    if (!values.name) {
        errors.name = 'El campo de nombre no debe estar vacio';
    }

    if (!values.telefono) {
        errors.telefono = 'El campo de nombre no debe estar vacio';
    }
    /*if (!values.regime) { telephone
        errors.regime = 'debes seleccionar un regimen';
    }*/
    /* if (!values.clientGroup) {
         errors.clientGroup = 'el grupo de cliente no debe estar vacio';
     }*/

    /*if (!values.website) {
         errors.website = 'la pagina web no debe estar vacio';
     } else if(!/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i.test(values.website)){
         errors.website = 'no es una dirección web valida';
     }*/

    if (!values.country) {
        errors.country = 'El campo de país no debe estar vacio';
    }
    if (!values.department) {
        errors.department = 'El campo de departamento no debe estar vacio';
    }
    if (!values.city) {
        errors.city = 'El campo de ciudad no debe estar vacio';
    }
    if (!values.email) {
        errors.email = 'El campo de email no debe estar vacio';
    } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i.test(values.email)) {
        errors.email = 'No es una dirección de correo valida';
    }

    if (!values.address) {
        errors.address = 'El campo de dirección no debe estar vacio';
    }
    if (!values.resolution && !discountCard) {
        errors.resolution = 'El campo de resolución no debe estar vacio';
    }
    if (!values.sgss && !discountCard) {
        errors.sgss = 'El campo de sgss no debe estar vacio';
    }

    /* if (!values.days) {
        errors.days = 'El campo de dias de vencimiento no debe estar vacio';
    } else if (String(values.days).length >= 5) {
        errors.days = 'El campo de dias de vencimiento debe tener una longitud maxima de 5';
    }

    if (!values.particular) {
        errors.particular = 'debes seleccionar una opción';
    }

    if (!values.history) {
        errors.history = 'debes seleccionar una opción';
    } */

    return errors;
};

function isCheckOK(nit) {   

    if (nit[9] !== '-') {
        return false;
    } else if (nit.length !== 11) {
        return false;
    } else if (isNaN(nit[10]) || isNaN(nit.substring(0,9))) {
        return false;
    } else {
        return true;
    }
}


export default validate;